import { AxiosError } from "axios";

import { Api } from "@/models/class/api.class";
import { Pagination } from "@/models/constant/interface/common.interface";
import { ErrorResponseModel } from "@/models/interface/http.interface";
import {
  UploadTaxIncomeHistoryParams,
  UploadTaxIncomeHistoryResponseDto,
} from "@/models/interface/upload-tax-income/UploadTaxIncomeHistoryResponseDto.interface";

import { HttpClient } from "./HttpClient.service";

export class UploadTaxIncomeService extends HttpClient {
  constructor() {
    super();
  }

  public downloadTemplateTaxIncome(): Promise<Blob> {
    return this.get<Blob>(Api.DownloadTemplateTaxIncome, {
      responseType: "blob",
    })
      .then(this.success)
      .catch((error: AxiosError<ErrorResponseModel>) => {
        throw this.error(error);
      });
  }

  public downloadTaxIncome(path: string): Promise<Blob> {
    return this.get<Blob>(`${Api.DownloadTaxIncome}/${path}`, {
      responseType: "blob",
    })
      .then(this.success)
      .catch((error: AxiosError<ErrorResponseModel>) => {
        throw this.error(error);
      });
  }

  public uploadTaxIncome(formData: FormData): Promise<void> {
    return this.post<void>(Api.UploadTaxIncome, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    })
      .then(this.success)
      .catch((error: AxiosError<ErrorResponseModel>) => {
        throw this.error(error);
      });
  }

  public historyUpload(
    params?: UploadTaxIncomeHistoryParams
  ): Promise<Pagination<UploadTaxIncomeHistoryResponseDto>> {
    return this.get<Pagination<UploadTaxIncomeHistoryResponseDto>>(
      Api.HistoryUploadTaxIncome,
      {
        params,
      }
    )
      .then(this.success)
      .catch((error: AxiosError<ErrorResponseModel>) => {
        throw this.error(error);
      });
  }

  public processTaxIncome(id: string): Promise<void> {
    return this.post<void>(`${Api.ProcessUploadTaxIncome}/${id}`)
      .then(this.success)
      .catch((error: AxiosError<ErrorResponseModel>) => {
        throw this.error(error);
      });
  }
}

export const uploadTaxIncomeService = new UploadTaxIncomeService();
